import { IEventSystem } from "@dhx/ts-common/events";
import { Layout } from "@dhx/ts-layout";
import { IAnyObj } from "@dhx/ts-common/types";

export enum TimepickerEvents {
	change = "change",
	save = "save",
	close = "close"
}

export interface ITimepickerConfig {
	css?: string;
	timeFormat?: 12 | 24;
	actions?: boolean;
}

export interface ITimepicker {
	config: ITimepickerConfig;
	events: IEventSystem<TimepickerEvents>;

	layout: Layout;
	paint(): void;
	getValue(asOBject?: boolean): IAnyObj | string;
	setValue(value: Date | number | string | any[]): void;
	destructor(): void;
}

export interface ITimeObject {
	hour: number;
	minute: number;
	AM?: boolean;
}